import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api';

export const AUTH_SIGNIN_REQUEST = 'AUTH_SIGNIN_REQUEST';
export const AUTH_SIGNIN_SUCCESS = 'AUTH_SIGNIN_SUCCESS';
export const AUTH_SIGNIN_FAILURE = 'AUTH_SIGNIN_FAILURE';

export const AUTH_SIGNUP_REQUEST = 'AUTH_SIGNUP_REQUEST';
export const AUTH_SIGNUP_SUCCESS = 'AUTH_SIGNUP_SUCCESS';
export const AUTH_SIGNUP_FAILURE = 'AUTH_SIGNUP_FAILURE';

export const AUTH_FORGOT_REQUEST = 'AUTH_FORGOT_REQUEST';
export const AUTH_FORGOT_SUCCESS = 'AUTH_FORGOT_SUCCESS';
export const AUTH_FORGOT_FAILURE = 'AUTH_FORGOT_FAILURE';

export const AUTH_SET_PASSWORD_REQUEST = 'AUTH_SET_PASSWORD_REQUEST';
export const AUTH_SET_PASSWORD_SUCCESS = 'AUTH_SET_PASSWORD_SUCCESS';
export const AUTH_SET_PASSWORD_FAILURE = 'AUTH_SET_PASSWORD_FAILURE';

export function signIn(login, password) {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}token/sign-in`,
      method: 'POST',
      body: JSON.stringify({
        username: login,
        password: password,
      }),
      types: [
        'AUTH_SIGNIN_REQUEST',
        'AUTH_SIGNIN_SUCCESS',
        {
          type: 'AUTH_SIGNIN_FAILURE',
          meta: (action, state, res) => {
            if (res) {
              return {
                status: res.status,
                statusText: res.statusText,
              };
            } else {
              return {
                status: 'Network request failed',
              };
            }
          },
        },
      ],
    },
  };
}

export function resetPassword(email) {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}token/reset-password/?email=${encodeURIComponent(
        email,
      )}`,
      method: 'GET',
      types: [
        'AUTH_FORGOT_REQUEST',
        'AUTH_FORGOT_SUCCESS',
        'AUTH_FORGOT_FAILURE',
      ],
    },
  };
}

export function setNewPassword(data) {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}token/reset-password`,
      method: 'POST',
      body: JSON.stringify(data),
      types: [
        'AUTH_SET_PASSWORD_REQUEST',
        'AUTH_SET_PASSWORD_SUCCESS',
        'AUTH_SET_PASSWORD_FAILURE',
      ],
    },
  };
}

export function signUp(data) {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}token/sign-up`,
      method: 'POST',
      body: JSON.stringify(data),
      types: [
        'AUTH_SIGNUP_REQUEST',
        'AUTH_SIGNUP_SUCCESS',
        'AUTH_SIGNUP_FAILURE',
      ],
    },
  };
}



// WEBPACK FOOTER //
// ./src/store/auth/AuthActions.js